/*eslint-disable */
<template>
  <b-container fluid>
    <div class="iq-card p-3 row justify-content-between">
      <div>
        <h4>
          <i class="ri-file-chart-line" aria-hidden="true" style="font-size: 21px; margin-right: 3px; color: var(--iq-primary);"></i>&nbsp;
          {{cvCardTitle}}
        </h4>
      </div>
      <div v-if="spcmStudentMeetingList && Array.isArray(spcmStudentMeetingList) && spcmStudentMeetingList.length > 0">
        <div class="bg-white shadow-sm rounded-5 p-2 cursor-pointer">
          <i :title="csvTitle" class="fa-solid fa-file-csv primary-color pointer" style="font-size: 20px;" @click="spcmAnalyticsStudentMeeting(false, true)"></i>
        </div>
      </div>
    </div>
    <iq-card class="py-3">
      <template v-slot:headerTitle>
        <b-row class="flex-column flex-md-row justify-content-md-between">
          <b-col style="max-width: max-content !important;">
              <h4 class="card-title pb-2 pt-0">
                <div class="profile-img-edit">
                  <img v-if="studentData.image" class="profile-pic border" :src="studentData.image? studentData.image : vmUserImage" alt="profile-pic" style=" height: 50px; width: 50px; object-fit: cover;"/>
                  <b-avatar v-else class="avatar-20 mr-2 border" :text="getFirstLetterOfAString(studentData.user_name)"></b-avatar>
                  <span class="pl-2">
                    <div style="height: 40px;" class="d-flex align-items-center">
                        <span class="pointer primary-color" @click="gotoUserProfile(studentData.user_id)">{{ studentData.user_name }}</span>
                    </div>
                    <b-badge v-if="SPCM_STATE_LIST && Object.keys(SPCM_STATE_LIST).length" class="text-wrap" :style="getCounsellingStateColorCode(applicationStatus)"> <small>{{ SPCM_STATE_LIST[applicationStatus] || "-"}}</small></b-badge>
                  </span>
                </div>
              </h4>
              <ul class="p-0 mb-1 user_details" style="line-break:anywhere">
                <span v-if="userData.user_role=='USERROLE11111' || userData.user_role=='USERROLE11118'">
                  Id:&nbsp;{{ studentData.user_id }}
                </span>
                <li><i class="fa fa-envelope" aria-hidden="true"></i> {{ studentData.user_email }}</li>
                <li><i class="fa fa-phone" aria-hidden="true"></i> {{ studentData.user_mobile }}</li>
              </ul>
              <b>Lead Strategist:&nbsp;{{ spcmObj.counsellor_name }}</b><br>
          </b-col>
          <b-col style="max-width: max-content !important;">
            <ul class="p-0 mb-1 user_details" style="line-break:anywhere; width: auto !important;">
              <b>Parents Details</b>
              <li v-for="(item, index) of parentList" :key="index+item">
              <i class="fa fa-user" aria-hidden="true"></i> {{item.parent_name}} {{item.parent_type ? `(${ item.parent_type })` : ""}}<br>
              <i v-if="item.parent_email" class="fa fa-envelope" aria-hidden="true"></i>  {{item.parent_email}}<br>
              <i v-if="item.parent_mobile" class="fa fa-phone" aria-hidden="true"></i> {{ item.parent_mobile }}
              </li>
              <li v-if="addressObj?.addressLineTwo"><i class="fa fa-map-marker font-size-18" aria-hidden="true"></i> {{ addressObj.addressLineTwo }} {{ addressObj.user_city }} {{ addressObj.user_state }}</li>
            </ul>
          </b-col>
        </b-row>
      </template>
    </iq-card>
    <iq-card class="px-3 py-4">
      <b-row>
        <!-- Counselor Name Filter -->
        <b-col class="mb-2 col-12 col-md-6 col-lg-4">
          <select v-model="whereFilter.counsellor_id" class="form-control" @change="handleFilterChange" v-if="counsellorObjList.length > 0" title="Counselor List">
            <option :value="null">All</option>
            <option v-for="(counsellor, index) of sortedCounsellorList" :key="(index+1)" :value="counsellor.user_id">
              {{counsellor.user_name}}
            </option>
          </select>
        </b-col>
        <!-- Counselor Name Filter -->
        <!-- Lookback filter -->
        <b-col class="mb-2 col-12 col-md-6 col-lg-4">
          <select v-model="whereFilter.lookbackFilter" class="form-control" @change="handleFilterChange()">
            <option value="month">Month wise</option>
            <option value="week">Week wise</option>
          </select>
        </b-col>
        <!-- Lookback filter -->
        <!-- date filter -->
        <b-col class="mb-2 col-12 col-md-6 col-lg-4">
          <!-- <datetime
            type="date"
            v-model="whereFilter.dateFilter"
            input-class="gide_datetime_input"
            class="datetime-theme-primary col-12 px-0"
            :format="{ year: 'numeric', month: 'long', day: 'numeric' }"
            :phrases="{ ok: 'Continue', cancel: 'Exit' }"
            :week-start="7"
            :max-datetime="getCurrentDate()"
            @input="handleFilterChange()">
          </datetime> -->
          <b-col class="w-100 p-0">
            <date-range-picker opens="left" class="w-100" ref="picker" :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy' }"  v-model="whereFilter.dateRange" @update="handleFilterChange"></date-range-picker>
          </b-col>
        </b-col>
        <!-- date filter -->
      </b-row>
    </iq-card>
    <div :style="{ minHeight: (!spcmStudentMeetingList || spcmStudentMeetingList?.length === 0) ? '400px' : 'auto'}" class="iq-card row p-3 d-flex align-items-center">
      <b-col md="12" v-if="spcmStudentMeetingList && Array.isArray(spcmStudentMeetingList) && spcmStudentMeetingList.length > 0">
        <b-table
          hover
          responsive
          :items="spcmStudentMeetingList"
          :fields="columns"
          :no-border-collapse="true"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          scrollable
        >
          <template v-slot:cell(id)="data">
            <span style="display: block;width: 50px">{{spcmStudentMeetingList.indexOf(data.item)+1}}</span>
          </template>
          <template v-slot:cell(counselor_name)="data">
            <span :title="data.item.counselor_name">{{ data.item.counselor_name }}</span><br>
            <small class="text-nowrap">Id:&nbsp;{{ data?.item?.counselor_id }}&nbsp;&nbsp;<i class="fa-solid fa-copy pointer" title="Copy Counselor Id" @click="doCopy( data?.item?.counselor_id)"></i></small><br>
            <small class="text-nowrap">Email:&nbsp;{{ data?.item?.counselor_email }}&nbsp;&nbsp;<i class="fa-solid fa-copy pointer" title="Copy Counselor Email" @click="doCopy( data?.item?.counselor_email)"></i></small><br>
          </template>
          <template v-slot:cell(meetings)="data">
            <span v-for="(meeting, index) in data.item.meetings" :key="meeting.session_id">
              <b-badge @click="openMeetingDetailsModal(meeting)" variant="primary" class="text-wrap pointer mr-2 bg-primary">
                Meeting {{ index + 1 }}
              </b-badge>
            </span>
          </template>
        </b-table>
        <div class="d-flex align-items-center mt-3 py-3">
          <b-col v-if="(currentBatchNo * dataPerPage) < totalDataCount" sm="7" md="8" class="my-1">
              <b-btn variant="primary" @click="loadMoreData">Load More</b-btn>
          </b-col>
        </div>
      </b-col>
      <b-col v-else-if="spcmStudentMeetingList && Array.isArray(spcmStudentMeetingList) && spcmStudentMeetingList.length === 0">
        <h5 class="text-secondary text-center">No matching meetings found.</h5>
      </b-col>
      <b-col v-else class="text-center py-5">
        <b-spinner variant="primary" class="align-middle"></b-spinner>
        <h5 class="mt-3 text-primary">Loading Meetings...</h5>
        <p class="text-muted mb-0">Please wait while Meeting records are being loaded.</p>
      </b-col>
    </div>

    <b-modal v-model="showModal" hide-footer centered title="Activity Details" header-class="border-0 pb-0">
      <SpcmActivityDetails :propSessionId="selectedSessionId" :propActivity="{}" @emitCloseActivityDetails="showModal = false" />
    </b-modal>
  </b-container>
</template>

<script>
// import "vue-datetime/dist/vue-datetime.css"
import { socialvue } from "../../../config/pluginInit.js"
import Utility from "../../../Utils/utility.js"
import { Spcms } from "../../../FackApi/api/Spcm.js"
import userPermission from "../../../Utils/user_permission.js"
import moment from "moment/moment.js"
import SpcmActivityDetails from "../../../components/SpcmActivityDetails.vue"
// import { Datetime } from "vue-datetime"

export default {
  name: "SpcmAnalyticsStudentMeetings",
  components: {
    SpcmActivityDetails
    // Datetime
  },
  data () {
    return {
      apiName: "spcm_analytics_student_meetings",
      cvCardTitle: "Student Meetings Analytics",
      spcmObj: {},
      studentData: {},
      parentList: [],
      SPCM_STATE_LIST: {},
      SPCM_STATE_COLORCODE_LIST: {},
      addressObj: {},
      applicationStatus: null,
      spcmStudentMeetingList: null,
      currentBatchNo: 1,
      dataPerPage: 25,
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Spcm Student Meetings",
      sortBy: "name",
      sortDesc: false,
      whereFilter: {
        lookbackFilter: "month",
        // dateFilter: new Date().toISOString().split("T")[0],
        counsellor_id: null,
        dateRange: {
          startDate: moment().subtract(1, "year"),
          endDate: moment()
        }
      },
      counsellorObjList: [],
      totalDataCount: 0,
      selectedSessionId: null,
      showModal: false,
      csvTitle: "Download student meetings"
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    },
    sortedCounsellorList () {
      return [...this.counsellorObjList].sort((a, b) =>
        a.user_name.localeCompare(b.user_name)
      )
    },
    columns () {
      return [
        { label: "#", key: "id", class: "text-left align-text-top", sortable: true },
        { label: "Counselor Info", key: "counselor_name", class: "text-left align-text-top", sortable: true },
        {
          label: this.whereFilter.lookbackFilter === "week" ? "Week Wise" : "Month Wise",
          key: "period",
          class: "text-left align-text-top",
          sortable: true
        },
        { label: "Total Meetings", key: "total_meeting_count", class: "text-left align-text-top", sortable: true },
        { label: "Meetings", key: "meetings", class: "text-left align-text-top", sortable: true }
      ]
    }
  },
  async beforeMount () {
    // Permission check for Counselor role
    if (this.userData.user_role == "USERROLE11118" && this.spcmObj.counsellor_id != this.userData.user_id) {
      if (!userPermission(this, this.userData, this.apiName)) {
        this.$router.back()
      }
    }
  },
  async mounted () {
    socialvue.index()
    const spcmId = this.$route.params.spcmId
    const spcmResp = await Spcms.spcmView(this, spcmId)

    if (spcmResp.resp_status) {
      this.spcmObj = spcmResp.resp_data.data
      this.applicationStatus = this.spcmObj.spcm_state

      if (this.userData.user_id === this.spcmObj.user_id) {
        this.studentData = this.userData
      }
      else {
        this.studentData = spcmResp.resp_data.user_detail
        this.addressObj = JSON.parse(this.studentData.user_address || "{}")
      }

      if (spcmResp.resp_data.user_parent_list && Array.isArray(spcmResp.resp_data.user_parent_list)) {
        this.parentList = spcmResp.resp_data.user_parent_list
      }
    }

    this.spcmStateList()
    let counselorTeamPayload = { "student_counselor_team": this.spcmObj.counselor_team, "spcm_id": this.spcmObj.spcm_id }
    this.StudentCounselorTeamList(counselorTeamPayload)
    this.spcmAnalyticsStudentMeeting()
  },
  methods: {
    /**
     * openMeetingDetailsModal
     */
    openMeetingDetailsModal (meeting) {
      this.selectedSessionId = meeting.session_id
      this.showModal = true
    },
    /**
     * getFirstLetterOfAString
     */
    getFirstLetterOfAString (string) {
      if (string) {
        return string.substr(0, 1)
      }
    },
    /**
     * gotoUserProfile
     */
    gotoUserProfile (userId) {
      Utility.openUrlInNewTab(`/user/${userId}`, "_blank")
    },
    /**
     * Student Counselor Team List
     */
    async StudentCounselorTeamList (payload) {
      try {
        let studentCounselorTeamResp = await Spcms.StudentCounselorTeamList(this, payload)
        if (studentCounselorTeamResp.resp_status) {
          this.counsellorObjList = studentCounselorTeamResp.resp_data.data
        }
      }
      catch (err) {
        console.error("Exception occurred at StudentCounselorTeamList() and Exception:", err.message)
      }
    },
    /**
     * spcmStateList
     */
    async spcmStateList () {
      try {
        let spcmStateListResp = await Spcms.spcmStateList(this)
        if (spcmStateListResp.resp_status) {
          let stateObjList = spcmStateListResp.resp_data.data
          for (let stateObj of stateObjList) {
            this.$set(this.SPCM_STATE_LIST, stateObj.state_id, stateObj.state)
            this.$set(this.SPCM_STATE_COLORCODE_LIST, stateObj.state_id, stateObj.state_color_code)
          }
        }
      }
      catch (err) {
        console.error("Exception occurred at spcmStateList() and Exception:", err.message)
      }
    },
    /**
     * get Counselling State Color Code
     */
    getCounsellingStateColorCode (stateId) {
      if (stateId == 99) {
        return `vertical-align: middle; color: #FFF; background: orange !important;`
      }
      else if (stateId == 98) {
        return `vertical-align: middle; color: #FFF; background: #e5252c !important;`
      }
      else {
        return `vertical-align: middle; color: #FFF; background: ${this.SPCM_STATE_COLORCODE_LIST[stateId]} !important;`
      }
    },
    /**
     * getCurrentDate
     */
    getCurrentDate () {
      return new Date().toISOString().split("T")[0]
    },
    /**
     * handleFilterChange
     */
    async handleFilterChange () {
      this.currentBatchNo = 1
      this.spcmAnalyticsStudentMeeting(false)
    },
    /**
     * spcmAnalyticsStudentMeeting
     */
    async spcmAnalyticsStudentMeeting (loadViaLoadMore = false, downloadCsv = false) {
      try {
        this.whereFilter.currentBatchNo = this.currentBatchNo
        this.whereFilter.dataPerPage = this.dataPerPage
        this.whereFilter.downloadCsv = downloadCsv

        let payload = {
          spcm_id: this.spcmObj.spcm_id,
          whereFilter: this.whereFilter
        }

        let spcmListResp = await Spcms.spcmAnalyticsStudentMeeting(this, payload)
        if (spcmListResp.resp_status) {
          if (downloadCsv) {
            window.open(spcmListResp.resp_csv_file_url)
            return
          }

          spcmListResp.resp_data.data = spcmListResp.resp_data.data.map(item => ({
            ...item,
            meetings: item.meetings ? JSON.parse(item.meetings) : []
          }))

          if (!loadViaLoadMore) {
            this.spcmStudentMeetingList = [ ...spcmListResp.resp_data.data ]
          }
          else {
            this.spcmStudentMeetingList = [ ...this.spcmStudentMeetingList, ...spcmListResp.resp_data.data ]
          }

          // this.spcmStudentMeetingList.forEach((s, index) => { s.id = index + 1 })
          this.totalDataCount = spcmListResp.resp_data_total_count
        }
        else {
          this.toastMsg = spcmListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
          this.spcmStudentMeetingList = []
        }
      }
      catch (err) {
        this.toastMsg = "Failed to fetch counselor students. Please try again."
        this.toastVariant = "danger"
        this.showToast = true
        this.spcmStudentMeetingList = []
        console.error("Exception occurred at spcmAnalyticsStudentMeeting() and Exception:", err.message)
      }
    },
    /**
     * loadMoreData
     */
    async loadMoreData () {
      this.currentBatchNo = this.currentBatchNo + 1
      this.spcmAnalyticsStudentMeeting(true)
    }
  }
}
</script>
<style lang="scss" scoped>
.logo-icon{
  height: 50px !important;
  width: 50px !important;
  overflow: hidden;
  object-fit: cover;
  pointer-events: none;
  border-radius: 50%;
}
.w-full{
  width: 100%;
}
.iq-header-title{
  width: 100%;
}
div.profile-img-edit{
  display: flex !important;
  align-items: center !important;
  height: unset !important;
  width: auto !important;
}
.user_details i{
  color: #e5252c;
  width: 15px
}
</style>
